import {ROLES} from "../../../../utils/constants";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleCheck} from "@fortawesome/free-solid-svg-icons";
import React from "react";

export const RoleSelector = ({userRole, selectedRole, onChangeRole}) => {
  return (
    <div className={"h-[175px]"}>
      <span className="mb-2">請選擇貼心到宅平台之角色:</span>
      <div className="flex space-x-2 overflow-x-scroll">
        {ROLES
          .filter(role => role.value !== '')
          .filter(role => role.canManageRoles.some(r => userRole.includes(r)))
          .map((role) => (
            <label
              key={role.value}
              className={`cursor-pointer flex flex-row items-center px-4 py-1 rounded-lg gap-x-2 border-4 ${
                selectedRole === role.value ? 'border-ptTeal' : 'border-white'
              } ${role.bgGradient} transition-all text-nowrap`}
            >
              <input
                type="radio"
                name="role"
                value={role.value}
                className="hidden"
                checked={selectedRole === role.value}
                onChange={() => onChangeRole(role.value)}
              />
              <FontAwesomeIcon icon={role.icon} className="text-sm"/>
              <span className="text-sm">{role.label}</span>
            </label>
          ))}
      </div>

      {selectedRole !== '' &&
        <div className="rounded-xl p-2 mt-2 bg-purple-100">
          {selectedRole === 'god' && (
            <table>
              <tbody>
              <tr>
                <td>
                  <FontAwesomeIcon icon={faCircleCheck} className="text-ptTeal"/>
                </td>
                <td className={"pl-2"}>
                  管理業務組別清單
                </td>
              </tr>
              <tr>
                <td>
                  <FontAwesomeIcon icon={faCircleCheck} className="text-ptTeal"/>
                </td>
                <td className={"pl-2"}>
                  管理全平台總管理、科室人員、機構人員
                </td>
              </tr>
              <tr>
                <td>
                  <FontAwesomeIcon icon={faCircleCheck} className="text-ptTeal"/>
                </td>
                <td className={"pl-2"}>
                  派案權限、案件管理
                </td>
              </tr>
              </tbody>
            </table>
          )}
          {selectedRole === 'admin' && (
            <table>
              <tbody>
              <tr>
                <td>
                  <FontAwesomeIcon icon={faCircleCheck} className="text-ptTeal"/>
                </td>
                <td className={"pl-2"}>
                  管理該組別之業務組別清單
                </td>
              </tr>
              <tr>
                <td>
                  <FontAwesomeIcon icon={faCircleCheck} className="text-ptTeal"/>
                </td>
                <td className={"pl-2"}>
                  管理該組別之科室人員、機構人員
                </td>
              </tr>
              <tr>
                <td>
                  <FontAwesomeIcon icon={faCircleCheck} className="text-ptTeal"/>
                </td>
                <td className={"pl-2"}>
                  派案權限、管理該組別案件
                </td>
              </tr>
              </tbody>
            </table>
          )}
          {selectedRole === 'worker' && (
            <table>
              <tbody>
              <tr>
                <td>
                  <FontAwesomeIcon icon={faCircleCheck} className="text-ptTeal"/>
                </td>
                <td className={"pl-2"}>
                  管理該機構案件
                </td>
              </tr>
              </tbody>
            </table>
          )}
        </div>
      }
    </div>
  )
}
